import clsx from 'clsx'
import PropTypes from 'prop-types'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import Button from 'components/common/button'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

const ListTabs = ({ tabs, handleClick, isTabSelected, t }) => (
  <div className="list-tabs">
    <style jsx>{styles}</style>
    {tabs.map((item) => (
      <Button
        key={item.key}
        className={clsx('list-tabs__label', {
          active: isTabSelected(item.tab),
        })}
        type={BUTTON_TYPES.text}
        onClick={() => handleClick(item.tab)}
      >
        <span className={Typo.subtitle1}>
          {hasLocizeTranslation(t, item.key, item.text)}
        </span>
        <span className={clsx(Typo.body2, 'list-tabs__number')}>
          ({item.num})
        </span>
      </Button>
    ))}
  </div>
)

ListTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tab: PropTypes.string,
      key: PropTypes.string,
      text: PropTypes.string,
      num: PropTypes.number,
    }),
  ).isRequired,
  handleClick: PropTypes.func.isRequired,
  isTabSelected: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ListTabs)
